/**
 * 全域 body scroll lock 管理器
 * 使用引用計數，確保多個 Modal/Menu 同時 lock 時不會互相干擾
 */
let lockCount = 0;

export function lockScroll() {
  lockCount++;
  if (lockCount === 1) {
    document.body.style.overflow = 'hidden';
  }
}

export function unlockScroll() {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    document.body.style.overflow = '';
  }
}
